(function () {
  const SLIDE_MS = 300;

  const toggleAccordion = ($toggle) => {
    const $descriptions = $toggle.siblings(".about__accordion-description");

    if (!$toggle.hasClass("active")) {
      $toggle.addClass("active").attr("aria-expanded", "true");
      $descriptions.eq($toggle.index()).stop().slideDown(SLIDE_MS);
    } else {
      $toggle.removeClass("active").attr("aria-expanded", "false");
      $descriptions.stop().slideUp(SLIDE_MS);
    }
  };

  const initProductAccordion = () => {
    const $toggles = $(".about__accordion-toggle");
    if (!$toggles.length) return;

    // Initial ARIA state + focusability for non-button toggles
    $toggles.each(function () {
      const $toggle = $(this);
      $toggle.attr("aria-expanded", $toggle.hasClass("active") ? "true" : "false");

      if (!$toggle.is("button")) {
        $toggle.attr({ role: "button", tabindex: "0" });
      }
    });

    // Namespaced events so re-init on section:load doesn't stack handlers
    $toggles
      .off(".aboutAccordion")
      .on("click.aboutAccordion", function () {
        toggleAccordion($(this));
      })
      .on("keydown.aboutAccordion", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault(); // stops the native click and page scroll
          toggleAccordion($(this));
        }
      });
  };

  document.addEventListener("shopify:section:load", initProductAccordion);
  initProductAccordion();
})();

/* old code without keyevent
(function () {
	const initProductAccordion = () => {
		$('.about__accordion-toggle').click(function() {
			if (!$(this).hasClass('active')) {
				$(this).addClass('active');
				$(this).siblings('.about__accordion-description').eq($(this).index()).stop().slideDown(300);
			} else {
				$(this).removeClass('active');
				$(this).siblings('.about__accordion-description').stop().slideUp(300);
			}
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();*/
